export default __webpack_public_path__ + "static/media/banner bem-vindo 2024.3ea4a1d6.jpg";